module.exports = __webpack_public_path__ + "2a4ea8b65213039209313f0541041991.MP3";